
const getDefaultState = () => {
  return {
    validProductCodes: [
       // SMASS-Triage
      'c6781ba2-50fb-4576-be28-4bd892fc90a3',
      // Apohealth
      '7de537da-2b83-4608-a1d7-3117bb2bbfd9',
      // Covid guide short
      'ed43abfd-f326-41a7-b0fb-2192c9a497d5',
      // Covid guide integrated
      '89ebc343-1f7e-40bf-8b33-d0d73878761c',
      // SmED Kontakt
      '12865a4a-d05a-45b2-9762-9f6566b0eb4e',
       // SmED Kontakt+
       'c1a5e3f5-6ba1-4635-864b-c3c55873750f',
        // Care
        '4f48d09d-6ebb-442a-9e5f-c332dece99a2',
       // extra codes, not used yet
       'c2a653f1-90d5-4ac1-a857-bbdb65dd211b',
       '39b3c1ca-8a9c-46c1-a0b4-53d416346232',
       '46ab7e89-c196-4fb1-a8ef-c12910c62d57'
    ],
    patientProfileData: {},
    msitat: null,
    assessmentToken: null,
    assessmentLanguage: null,
    productCode: null,
    pid: null,
    sex: null,
    dob: null,
    pregnancy: null,
    wop: null,
    woc: null,
    emergency: null,
    fetmov: null,
    vitparam:null,
    heartrate: null,
    brrate: null,
    oxsat: null,
    systbp: null,
    diastbp: null,
    btemp: null,
    blsugmmoll:null,
    blsugmgdl: null,
    breathing: null,
    hrtcirc: null,
    neuroment: null,
    abdomen: null,
    trauma: null,
    other: null,
    dc: null,
    emergind: null,
    errorMessages: [],
    errorKey: null,
}

};


// ======================================================================
// Initial State
// ======================================================================

const state = getDefaultState();

// ======================================================================
// Getters
// ======================================================================

const getters = {
    getPatientProfileData: state => state.patientProfileData,
    getMsitat: state => state.msitat,
    getAssessmentToken: state => state.assessmentToken,
    getAssessmentLanguage: state => state.assessmentLanguage,
    getValidProductCodes: state => state.validProductCodes,
    getPoductCode: state => state.productCode,
    getPid: state => state.pid,
    getSex: state => state.sex,
    getDob: state => state.dob,
    getPregnancy: state => state.pregnancy,
    getWeekOfPregnancy: state => state.wop,
    getWeekOfChildbed: state => state.woc,
    getEmergency: state => state.emergency,
    getFetalMovements: state => state.fetmov,
    getShowVitalParams: state => state.vitparam,
    getHeartFrequency: state => state.heartrate,
    getBreathFrequency: state => state.brrate,
    getOxygeneLevel: state => state.oxsat,
    getUpperBloodPressure: state => state.systbp,
    getLowerBloodPressure: state => state.diastbp,
    getBodyTemperature: state => state.btemp,
    getBloodSugarMoll: state => state.blsugmmoll,
    getBloodSugarMgdl: state => state.blsugmgdl,
    getBreathing: state => state.breathing,
    getHeartCirculation: state => state.hrtcirc,
    getNeurologicalMentalState: state => state.neuroment,
    getAbdomen: state => state.abdomen,
    getTrauma: state => state.trauma,
    getOther: state => state.other,

    getDc: state => state.dc,
    getEmergind: state => state.emergind,
    getErrorMessages: state => state.errorMessages,
    getErrorKey: state => state.errorKey
};


// ======================================================================
// Actions
// ======================================================================

const actions = {
};


// ======================================================================
// Mutations
// ======================================================================

const mutations = {


    setPatientProfileData (state, data){
        state.patientProfileData = data;
    },
    setMsitat (state, data){
        state.msitat = data;
    },
    setAssessmentToken (state, data){
        state.assessmentToken = data;
    },
    setAssessmentLanguage (state, data){
        state.assessmentLanguage = data;
    },
    setPregnancy (state, data){
        state.pregnancy = data;
    },
    setWeekOfPregnancy (state, data){
        state.wop = data;
    },
    setWeekOfChildbed (state, data){
        state.woc = data;
    },
    setEmergency (state, data){
        state.emergency = data;
    },
    setFetalMovements (state, data){
        state.fetmov = data;
    },
    setShowVitalParams (state, data){
        state.vitparam = data;
    },
    setHeartFrequency (state, data){
        state.heartrate = data;
    },
    setBreathFrequency (state, data){
        state.brrate = data;
    },
    setOxygeneLevel (state, data){
        state.oxsat = data;
    },
    setUpperBloodPressure (state, data){
        state.systbp = data;
    },
    setLowerBloodPressure (state, data){
        state.diastbp = data;
    },
    setBodyTemperature (state, data){
        state.btemp = data;
    },
    setBloodSugarMoll (state, data){
        state.blsugmmoll = data;
    },
    setBloodSugarMgdl (state, data){
        state.blsugmgdl = data;
    },
    setBreathing (state, data){
        state.breathing = data;
    },
    setHeartCirculation (state, data){
        state.hrtcirc = data;
    },
    setNeurologicalMentalState (state, data){
        state.neuroment = data;
    },
    setAbdomen (state, data){
        state.abdomen = data;
    },
    setTrauma (state, data){
        state.trauma = data;
    },
    setOther (state, data){
        state.other = data;
    },
    setProductCode (state, data){
        state.ProductCode = data;
    },
    setDob (state, data){
        state.dob = data;
    },
    setSex (state, data){
        state.sex = data;
    },
    setPid (state, data){
        state.pid = data;
    },
    setDc (state, data){
        state.dc = data;
    },
    setEmergind (state, data) {
        state.emergind = data
    },
    setErrorMessages (state, data){
        state.errorMessages.push(data);
    },
    setErrorKey (state, data) {
        state.errorKey = data;
    },
    clearErrorMessages (state){
        state.errorMessages = [];
    },
    clearProductCode(state){
        state.ProductCode = undefined;
    },


    // ---------------------------------------------------------

    resetStore (state) {
         Object.assign(state, getDefaultState());
    }
};


// ======================================================================
// Exports
// ======================================================================

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/common/store/modules/SubmittedValuesStore.js